import { Box, Flex, Link } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { colors } from '../../../../ui-kit'
import { MLContext } from '../../../providers'
import { PublicLinksInfoContext } from '../../../providers/PublicLinksInfoProvider'
import CopyMoveStatus from './CopyMoveStatus'
import Usage from './Usage'

const PanelContainer = styled(Box)`
  position: sticky;
  z-index: 2;
  bottom: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 24px;
  padding: 0 1em;
  gap: 1em;
  overflow: hidden;
  background-color: ${colors.appPaleGreyThree};
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
`

const Panel = (): React.ReactElement => {
  const { t } = useTranslation()
  const history = useHistory()

  const { isPublicLink } = useContext(PublicLinksInfoContext)
  const [{ operations }] = useContext(MLContext)
  const operationsCount = operations.length

  return (
    <PanelContainer>
      {!isPublicLink ? <Usage /> : null}
      <Flex ml="auto" gap="1em">
        <Link
          color="appDarkIndigo"
          fontSize="12px"
          padding="0 10px"
          _hover={{
            textDecoration: 'none',
            backgroundColor: 'appPaleGreyTwo',
          }}
          onClick={() => {
            history.push('/media-library/downloads')
          }}
        >
          {t('downloads', 'Downloads')}{' '}
          {operations.length > 0 ? (
            <Trans t={t} i18nKey="download_actions">
              (Processing {{ operationsCount }} zip file)
            </Trans>
          ) : null}
        </Link>
        {!isPublicLink ? <CopyMoveStatus /> : null}
      </Flex>
    </PanelContainer>
  )
}

export default Panel
